import React from 'react'
import Layout from '../../components/Layout'
import DownloadStyle from '../Download/DownloadStyle'
import { Spin } from 'antd'
import Button from '../../components/Button'
import html2PDF from 'html2pdf.js'
import { useLocation } from 'react-router-dom'
import moment from 'moment'

export default function AlertMessageRU() {
	const location = useLocation()
	const today = moment().format('DD/MM/YYYY')
	const { state } = location
	console.log(state)

	const formatter = new Intl.NumberFormat('ru-RU', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 3,
	})

	const download = () => {
		let element = document.getElementsByClassName('preduprezhdenie-pismo')[0]

		// Set A4 width minus margins to prevent text cutoff
		const a4WidthMm = 210
		const marginMm = 6 // 1cm on each side
		const contentWidthMm = a4WidthMm - marginMm * 2

		element.style.width = `${contentWidthMm}mm`
		element.style.maxWidth = '100%'
		element.style.boxSizing = 'border-box'

		html2PDF(element, {
			margin: [6, 6, 6, 6], // 1cm margins on all sides
			filename: 'preduprezhdenie-pismo.pdf',
			image: { type: 'jpeg', quality: 0.98 },
			html2canvas: {
				scale: 2,
				logging: false,
				letterRendering: true,
				useCORS: true,
			},
			jsPDF: {
				unit: 'mm',
				format: 'a4',
				orientation: 'portrait',
			},
		})
	}

	return (
		<Layout>
			<DownloadStyle style={{ backgroundColor: '#fff' }}>
				<Spin spinning={false}>
					<main className="max-w-[740px] flex flex-col gap-3 w-full mx-auto p-3 rounded-md">
						<div className="flex justify-end">
							<Button btnStyle={{ width: 150 }} onClick={download}>
								Скачать письмо
							</Button>
						</div>
						<div className="max-w-[740px] flex flex-col gap-3 w-full mx-auto p-3 rounded-md preduprezhdenie-pismo">
							<h1 className="text-xl font-bold text-center">
								CREDOMOBILEUZ{' '}
								<span className="block uppercase">
									ОФИЦИАЛЬНОЕ ПРЕДУПРЕДИТЕЛЬНОЕ ПИСЬМО
								</span>
							</h1>
							<div className="flex flex-col gap-1">
								<h2 className="text-md font-bold">
									Номер документа:{' '}
									<b className="text-red-500">
										CM/{today.split('/')[2]}/{state.docNum}
									</b>
								</h2>
								<h3 className="text-md">
									<b>Дата: </b>
									{today} года
								</h3>
							</div>
							<div className="flex flex-col gap-0 mt-3.5">
								<b className="text-md text-center">
									Уважаемый клиент,{state.cardName}, у вас выявлено
									несвоевременное внесение оговорённых платежей за товар,
									который вы приобрели в рассрочку в магазине техники
									“CREDOMOBILEUZ”.
								</b>
							</div>
							<div className="flex flex-col gap-1 mt-3.5 font-medium">
								<b className="text-md">Текущее состояние: </b>

								{/* <div className="grid grid-cols-2 mt-3.5 text-md font-bold"> */}
								<span>
									В нашей системе на вашем счёте на текущий момент имеется
									просроченная
								</span>
								<div className="grid grid-cols-2 text-md">
									<span>задолженность в размере</span>
									<b>{formatter.format(state.debtUntilToday)} долларов США.</b>
								</div>

								{/* <div className="flex flex-col gap-0">
										<span>
											В нашей системе на вашем счёте на текущий момент имеется
										</span>
										<span>просроченная задолженность.</span>
									</div>
									<span>
										{formatter.format(state.debtUntilToday)} долларов США на
										текущий момент
									</span> */}
								{/* </div> */}

								<div className="grid grid-cols-2 mt-3.5 text-md font-bold">
									<div className="flex flex-col gap-0">
										<span>Общая задолженность:</span>
									</div>
									<span>{formatter.format(state.debtTotal)} долларов США.</span>
								</div>
							</div>

							<div className="flex flex-col gap-1 mt-3.5">
								<h1 className="text-xl font-bold text-center">ПРЕДУПРЕЖДАЕМ</h1>
								<p
									className="mt-3.5"
									style={{
										textIndent: 30,
									}}
								>
									В соответствии с подписанным вами договором вы обязаны вносить
									ежемесячные платежи своевременно. До полного погашения
									задолженности приобретённая техника остаётся в залоге у{' '}
									<b>CREDOMOBILE</b>
								</p>
								<p
									className="font-bold mt-3.5"
									style={{
										textIndent: 30,
									}}
								>
									Если Вы не погасите задолженность полностью в течение 3
									рабочих дней с момента получения данного предупредительного
									письма, будут приняты следующие меры
								</p>
								<p className="mt-3.5">
									1. В соответствии с законодательством Республики Узбекистан,
									будет начата процедура{' '}
									<b>
										принудительного взыскания суммы задолженности с Вашего
										банковского счета и личных банковских карт.
									</b>
								</p>
								<p className="mt-3.5">
									2. Для ведения дела по задолженности{' '}
									<b>
										будет произведено обращение в махаллю, к инспектору по
										профилактике и другие соответствующие органы.
									</b>
								</p>
								<p className="mt-3.5">
									3. Информация о задолженности{' '}
									<b>негативно повлияет на Вашу финансовую историю.</b>
								</p>
							</div>
							<div className="w-full h-[1px] bg-black/80 mt-5" />
							<h2
								className="mt-2 font-bold text-md"
								style={{
									textIndent: 8,
								}}
							>
								<span className="text-red-500 font-extrabold">!</span>{' '}
								Пожалуйста, отнеситесь серьёзно к данному уведомлению и в
								течение 3 рабочих дней внесите платежи по задолженности.
							</h2>
							<div className="mt-2 flex flex-col gap-1">
								<b>Для дополнительной информации:</b>
								<div className="flex flex-col gap-0">
									<span>Тел:. {state.u_dunner_phone_number}</span>
									<span>Тел: {state.officeExtension}</span>
									<span>Телеграм: {state.u_dunner_telegram_name}</span>
								</div>
							</div>
						</div>
					</main>
				</Spin>
			</DownloadStyle>
		</Layout>
	)
}
